:host {
  display: block;
}

.firm-types-container {
  display: inline-flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  padding-bottom: 56px;
  /* background: #5e686e; */
  background: var(--ion-color-primary);
  padding: 24px 0px;
  box-shadow: inset 0px 6px 12px rgba(46, 61, 73, .4),
    inset 0px -6px 12px rgba(46, 61, 73, .4);
}

.firm-types-block {
  position: relative;
  width: 90vw;
  max-width: 1000px;
  height: auto;
  margin: 24px 4px 48px 4px;

  display: inline-flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

.firm-carrousel {
  max-width: 90vw;
}
.firm-slide {
  max-width: 380px;
}

/* @media only screen and (min-width: 300px) and (max-width: 420px) {
  .firm-slide {
    max-width: 80vw;
  }
} */
@media only screen and (max-width: 800px) {
  .firm-carrousel {
    max-width: 90vw !important;
  }
  .firm-slide {
    max-width: 90vw !important;
  }
}

.firm-img {
  transform: scaleX(1.0001);
}